import React from 'react';

const StickyWrapper = ({ position = 'sticky', topOffset = 0, children, className }) => {
    const stickyStyles = {
        position,
        top: topOffset,
    };
    return (
        <div style={stickyStyles} className={className}>
            {children}
        </div>
    );
};

export default StickyWrapper;
